import React, { useCallback, useState } from "react";
import { Flex, Form, Input, message, Select, Space, Typography } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { SubmitButton } from "@/components/button/submit-button";
import {
  LoginResponseSchema,
  OTPSchema,
} from "@/schemas";
import { publicRequest } from "@/services";
import { useNavigate } from "react-router-dom";

const onRequestSendOTP = async (body: OTPSchema) => {
  try {
    const result = await publicRequest<OTPSchema, LoginResponseSchema>({
      url: "/send-otp",
      method: "POST",
      data: body,
    });

    return result;
  } catch (error) {
    console.log(error);
  }
};

const LoginOTP: React.FC = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const [otpOptionValue, setOtpOptionValue] = useState("phone")

  const onFinish = () => {
    message.success("Submit success!");
  };

  const onFinishFailed = () => {
    message.error("Submit failed!");
  };

  const changeOtpOption = (value: { value: string; label: React.ReactNode }) => {
    setOtpOptionValue(value.value);
    console.log(value);
  };

  const onSendOTP = useCallback(async () => {
    try {
      const body = {
        phone: form.getFieldValue("phone"),
        email: form.getFieldValue("email"),
        type: otpOptionValue
      };

      const result = await onRequestSendOTP(body);
      if (result?.code == "200") {
        await localStorage.setItem("phone", body.phone);
        await localStorage.setItem("email", body.email);
        await localStorage.setItem("otp-type", otpOptionValue);
        message.success("ログインしました。");
        navigate("/admin/otp-verified", { replace: true });
      }
      else {
        if (otpOptionValue == "phone") {
          message.error("Phone number is invalid or doesn't match any account!");
        } else {
          message.error("Email is invalid or doesn't match any account!");
        }
      }
    } catch (error) {
      message.error("もう一度お試しください。");
    }
  }, [form, navigate, otpOptionValue]);

  return (
    <Flex gap="middle" align="center" vertical>
      <Typography.Text style={{ fontSize: 24, color: "#40C1A2" }}>
        管理機能
      </Typography.Text>

      <Typography.Text style={{ fontSize: 24 }}>ログイン</Typography.Text>
      <Space align="baseline">
        <Typography.Text style={{ fontSize: 16 }}>Select type send OTP</Typography.Text>
        <Select
          labelInValue
          defaultValue={{ value: 'phone', label: 'Phone' }}
          style={{ width: 120 }}
          onChange={changeOtpOption}
          options={[
            {
              value: 'phone',
              label: 'Phone',
            },
            {
              value: 'email',
              label: 'Email',
            },
          ]}
        />
      </Space>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        {otpOptionValue == "phone" ?
          <Form.Item
            name="phone"
            label="携帯電話番号"
            rules={[
              { required: true, message: "Please re-enter your phone" },
            ]}
          >
            <Input
              style={{ width: 360 }}
              size="large"
              type="phone"
              placeholder="Please enter your phone!"
              prefix={<UserOutlined />}
            />
          </Form.Item>
          :
          <Form.Item
            name="email"
            label="メールアドレス"
            rules={[
              { required: true, message: "Please re-enter your email" },
            ]}
          >
            <Input
              style={{ width: 360 }}
              size="large"
              type="email"
              placeholder="Please enter your email!"
              prefix={<UserOutlined />}
            />
          </Form.Item>}
      </Form>
      <Form.Item>
        <SubmitButton
          onClick={onSendOTP}
          styles={{ width: 360 }}
          form={form}
          title={"Send OTP"}
        />
      </Form.Item>

    </Flex>
  );
};

export default LoginOTP;
